<template>
    <div class="container">
        <div class="cousre-info">
            <div class="title">
                <p>{{ dataSources.name }}</p>
            </div>
            <div class="p flex rcs mt-1">
                <span class="title">代理商：</span>
                <span class="title">{{ dataSources.agent_name_text }}</span>
            </div>
            <div class="p flex rcs">
                <span class="title">时间：</span>
                <span class="title">{{ dataSources.start_time }} ~ {{ dataSources.expire_time_text }}</span>
            </div>
            <div class="p flex rcs">
                <span class="title">地址：</span>
                <span class="title">{{ dataSources.address }}</span>
            </div>
            <div class="total">
                <div class="tit td-fsc">
                    <img class="icon" :src="Images.icon_mine_logo3_2" />
                    <span>沙龙小计</span>
                </div>
                <div class="num-box">
                    <div class="box-item-wrap flex rcs">
                        <div class="num-item-wrap flex rcs">
                            <div class="title">报名人数：</div>
                            <div class="value">{{countInfo.enroll_num}}</div>
                        </div>
                        <div class="num-item-wrap flex rcs">
                            <div class="title">新学员：</div>
                            <div class="value">{{countInfo.new_student}}</div>
                        </div>
                        <div class="num-item-wrap flex rcs">
                            <div class="title">老学员：</div>
                            <div class="value">{{countInfo.old_student}}</div>
                        </div>
                    </div>
                    <div class="box-item-wrap flex rcs">
                        <div class="num-item-wrap flex rcs">
                            <div class="title">签到人数：</div>
                            <div class="value">{{countInfo.sign_num}}</div>
                        </div>
                        <div class="num-item-wrap flex rcs">
                            <div class="title">现场成交：</div>
                            <div class="value">{{countInfo.deal_num}}</div>
                        </div>
                        <div class="num-item-wrap flex rcs" v-if="user_type == Constants.USER_AGENT">
                            <div class="title">线下成交：</div>
                            <div class="value">{{countInfo.down_num}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollerView">
            <div class="table-wrap over-xs">
                <ul class="list-wrap user-list-wrap" :class="{'agent-table': user_type == Constants.USER_AGENT}" v-if="listData.length > 0">
                    <li class="list-item user-list-item list-header-wrap flex rcb">
                        <div class="flex ccc item-info-wrap item-info-wrap1 text-o">昵称</div>
                        <div class="flex ccc item-info-wrap item-info-wrap2 text-o" v-if="user_type == Constants.USER_AGENT">手机</div>
                        <div class="flex ccc item-info-wrap item-info-wrap3 text-o">代理商</div>
                        <div class="flex ccc item-info-wrap item-info-wrap3 text-o">学员类型</div>
                        <div class="flex ccc item-info-wrap item-info-wrap4 text-o">成交状态</div>
                        <div class="flex ccc item-info-wrap item-info-wrap5 text-o">签到状态</div>
                        <div class="flex ccc item-info-wrap item-info-wrap6 text-o" v-if="user_type == Constants.USER_AGENT">操作</div>
                    </li>
                    <li class="list-item user-list-item flex rcb" v-for="(item, index) in listData" :key="index">
                        <div class="flex ccc item-info-wrap item-info-wrap1 text-o">
                            <div class="value text-o">{{item.name}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap2 text-o" v-if="user_type == Constants.USER_AGENT">
                            <div class="value text-o">{{item.mobile}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap3 text-o">
                            <div class="value text-o">{{item.agent_name}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap3 text-o">
                            <div class="value text-o">{{item.student_type_text}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap4 text-o">
                            <div class="value text-o">{{item.enroll_status_text}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap5 text-o">
                            <div class="value text-o">{{item.is_sign_text}}</div>
                        </div>
                        <div class="flex ccc item-info-wrap item-info-wrap6 text-o btn-wrap" v-if="user_type == Constants.USER_AGENT">
                            <div class="btn-item" @click="onPressToSign(item)" v-if="item.is_sign == Constants.SIGN_STATUS_FALSE">
                                <div class="btn-title">签到</div>
                            </div>
                            <div class="btn-item" @click="onPressToUnlock(item)" v-if="item.is_sign != Constants.SIGN_STATUS_FALSE && item.student_type == Constants.USER_STU_NEW">
                                <div class="btn-title">解锁众修</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <van-empty description="暂无报名学员～" v-if="listData.length < 1 && !loading" />
        </div>
        <van-dialog v-model="isShowTicketPopup" title="请选择门票" show-cancel-button @confirm="_onPressToConfirmTicket" :beforeClose="_onCheckTicketParams">
            <div class="dialog-content flex ccc">
                <van-radio-group class="w100 flex rcb" v-model="signType" direction="horizontal">
                    <van-radio class="mr-0" :name="Constants.DEAL_ONLINE_VALUE">{{Constants.DEAL_ONLINE_TITLE}}</van-radio>
                    <van-radio class="mr-0" :name="Constants.DEAL_OFFLINE_VALUE">{{Constants.DEAL_OFFLINE_TITLE}}</van-radio>
                </van-radio-group>
                <div class="ticket-list-wrap cus-select-item">
                    <select name="ticket_no" v-model="ticket_no" class="ticket-select-wrap">
                        <option value="">请选择门票</option>
                        <option v-for="(item, index) in tickets" :key="index" :value="item.ticket_no">{{item.ticket_no}}</option>
                    </select>
                </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import courseRecordItem from "@/components/item/courseRecordItem";
export default {
    components: {
        courseRecordItem: courseRecordItem,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            loading: false,
            isShowTicketPopup: false,
            signType: this.Constants.DEAL_ONLINE_VALUE,
            selectItem: {},
            salon_id: this.$route.query.id || '',
            user_type: this.$route.query.user_type || this.Constants.USER_AGENT,
            dataSources: {},
            countInfo: {},
            listData: [],
            tickets: [],
            ticket_no: '',
        };
    },
    created() {
        this.requestData();
        this.requestMyTicketsData();
    },
    methods: {

        async _onSubmitRequest(url, data) {
            let result = await this.$post(url, data);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.requestData();
            }
        },

        // 获取门票数据
        async requestMyTicketsData() {
            let url = this.API.user_ticket_list;
            let data = {
                limit: 99,
                user_type: this.user_type,
                agent_id: this.userInfo.id,
                is_lock: this.Constants.TICKET_STATUS0,
            };
            let result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.tickets = result.data.data;
            } else {
                this.ToastManager(result.msg);
            }
        },

        // 列表数据
        async requestData() {
            let url = this.API.salon_enroll_list;
            let data = {
                id: this.salon_id,
                user_type: this.user_type,
            };
            let result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data.data;
                this.countInfo = result.data.count;
                this.listData = result.data.list;
                this._onStopLoading(true);
            } else {
                this.ToastManager(result.msg);
            }
        },

        refresh(done) {
            this.requestData();
            setTimeout(() => {
                done();
            }, 1000);
        },
        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },

        async onPressToSign(item) {
            let url = this.API.salon_do_sign;
            let data = {
                id: item.id,
            };
            this._onSubmitRequest(url, data);
        },

        async onPressToUnlock(item) {
            this.selectItem = item;
            this.isShowTicketPopup = true;
        },

        // 确认前检查门票是否选择
        _onCheckTicketParams(action, done) {
            if (action == 'confirm' && !this.ticket_no) {
                this.ToastManager('请先选择门票');
                return done(false);
            }
            done();
        },

        async _onPressToConfirmTicket() {

            let url = this.API.salon_buy_subject;
            let data = {
                type: this.signType,
                ticket_no: this.ticket_no,
                enroll_id: this.selectItem.id,
            };

            this._onSubmitRequest(url, data);
        },

    },
};
</script>
<style lang="less" scoped>
.container {
    height: 100vh;
    display: flex;
    flex-direction: column;

    .cousre-info {
        padding: 15px;
        background: #ffffff;
        border-radius: 3px;
        flex-shrink: 0;

        .title {
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 16px;
                color: #333;
                font-weight: 500;
            }
        }

        .p {
            font-size: 14px;
            color: #666;
            line-height: 24px;
        }

        .total {
            border-top: dashed #eee 1px;
            padding-top: 10px;
            margin-top: 10px;

            .tit {
                font-size: 15px;
                color: #333;
                font-weight: 500;

                .icon {
                    width: 16px;
                    height: 16px;
                    object-fit: contain;
                    margin-right: 6px;
                }
            }

            .num-box {
                padding-top: 10px;

                .num-item-wrap {
                    flex: 1;
                    max-width: 33.33%;
                }

                span {
                    font-size: 13px;
                    color: #333;
                }

                .num {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }

        >p {
            margin-top: 5px;
            font-size: 13px;
            color: #333;
        }
    }

    .scrollerView {
        flex: 1;
        width: 100%;
        background: #fff;
        position: relative;

        .scroller {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
    }

    .table-wrap {
        margin: 1rem 1rem;

        .user-list-wrap {
            background: #fff;
            border-radius: .5rem;

            &.agent-table {
                min-width: 180vw;

                .user-list-item {
                    .item-info-wrap {
                        min-width: 25vw;
                    }
                }
            }


            .user-list-item {
                height: 4rem;
                background: #efefef;

                &.list-header-wrap {
                    background: #2196f3;

                    .item-info-wrap {
                        color: #fff;
                    }
                }

                &:nth-child(even) {
                    background: #f7f8f9;
                }

                .item-info-wrap {
                    flex: 1;
                    color: #333;
                    height: 100%;
                    flex-shrink: 0;
                    text-align: center;
                    border-left: 1px solid #fff;

                    &:first-of-type {
                        border: 0;
                    }

                    &.item-info-wrap1 {}

                    &.item-info-wrap2 {}

                    &.item-info-wrap3 {}

                    &.item-info-wrap4 {}

                    &.item-info-wrap5 {}

                    &.item-info-wrap6 {}

                    .value {
                        width: 100%;
                        margin: 0 .2rem;
                    }

                    .btn-item {
                        color: #2196f3;
                    }
                }
            }

        }
    }

    .dialog-content.flex.ccc {
        padding: 3rem 5rem;

        .ticket-list-wrap {
            width: 100%;
            height: 3rem;
            overflow: hidden;
            margin-top: 2rem;
            text-align: center;
            border-radius: 0.5rem;
            border: 1px solid #ddd;

            .ticket-select-wrap {
                border: 0;
                color: #333;
                width: 100%;
                height: 100%;
                display: block;
                appearance: none;
                font-size: 1.4rem;
                text-indent: 1rem;
                text-align: center;
            }
        }

    }
}
</style>